import { useDispatch } from 'react-redux';
import { CollectionBannerWithLoader } from './loaders';

export const BannerCollections = () => {
    const dispatch = useDispatch();

    return <CollectionBannerWithLoader />;
};
